export const TILE_V2_DISPLAY_VERTICAL = 'vertical'
export const TILE_V2_DISPLAY_POSTER = 'poster'
export const TILE_V2_DISPLAY_DEFAULT = 'default'
export const TILE_V2_DISPLAY_ROUND = 'round'
export const TILE_V2_DISPLAY_TYPE_YOGA = 'yoga'
export const TILE_V2_TAGS_SIZE_DEFAULT = 'default'
export const TILE_V2_TAGS_SIZE_SMALL = 'small'
export const TILE_VERTICAL = 'tile-list-5x7'
export const TILE_GAIA_PLUS = 'tile-list-gaia-plus'
